import { Component, OnInit } from '@angular/core';
import * as L from 'leaflet';
import 'leaflet.pm';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../services/api.service'
declare var require: any
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import 'hammerjs';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery-9';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'app-project-viewer',
  templateUrl: './project-viewer.component.html',
  styleUrls: ['./project-viewer.component.css']
})
export class ProjectViewerComponent implements OnInit {

  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];

  public map: any;
  public map2: any;
  section = 1
  geo_province: any
  list_province: any
  name_province: any
  name_project: any = ''
  detail_project: any = {}
  detail_project2: any = {}
  detail_nproject: any = {}
  geoJSON: any = {}
  json_demo: any
  lat: any
  lon: any
  list_images: any = [] as any
  detail_type_project = [] as any
  detail_type_project2 = [] as any
  detail_type_project3 = [] as any
  detail_type_project4 = [] as any
  detail_type_project5 = [] as any
  detail_new_project = [] as any as any
  user: any
  select_id: any
  select_1 = [] as any
  select_2 = [] as any

  showmap: any = false;

  project_image: any = {};

  bounds: any;
  id_province: any;

  layer_marker: any = L.layerGroup();


  constructor(
    public router: Router,
    private _location: Location,
    private ActivatedRoute: ActivatedRoute,
    private http: HttpClient,
    public services: ApiService

  ) {

    //get id
    this.name_province = this.ActivatedRoute.snapshot.paramMap.get('id');
    this.json_demo = this.services.get_parcel_demo()

    this.services.getProvince().then((res: any) => {
      this.geo_province = res
      this.initMap(this.geo_province)
    });
    let data = {
      name_province: this.name_province,
    }
    this.services.get_all_newproject().then((res: any) => {

      res.forEach((e: any) => {
        if (e.id == this.name_province) {
          this.detail_new_project.push(e)
          this.detail_nproject = this.detail_new_project[0]
        }
      });

    });
    this.galleryOptions = [
      {
        width: '100%',
        height: '700px',
        thumbnailsColumns: 4,
        imageAnimation: NgxGalleryAnimation.Slide
      },
      // max-width 800
      {
        breakpoint: 800,
        width: '100%',
        height: '600px',
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20
      },
      // max-width 400
      {
        breakpoint: 400,
        preview: false
      }
    ];

    this.galleryImages = [] as any;
    this.services.query_image_data(data).then((res: any) => {

      if (res.length != 0) {
        res.forEach((e: any) => {
          this.list_images.push({ name: 'https://ogc.mapedia.co.th/api/v1/lrfund/image/' + e.image_name })

          this.galleryImages.push(
            {
              small: 'https://ogc.mapedia.co.th/api/v1/lrfund/image/' + e.image_name,
              medium: 'https://ogc.mapedia.co.th/api/v1/lrfund/image/' + e.image_name,
              big: 'https://ogc.mapedia.co.th/api/v1/lrfund/image/' + e.image_name
            }
          )

        });
      } else {
        this.list_images.push({ name: 'assets/images/placeholder.jpg' })

        this.galleryImages.push(
          {
            small: 'assets/images/placeholder.jpg',
            medium: 'assets/images/placeholder.jpg',
            big: 'assets/images/placeholder.jpg'
          }
        )
      }

    });


  }

  async ngOnInit() {
    let list = [] as any
    await this.services.get_all_funding().then((res: any) => {
      res.forEach((e: any) => {
        if (e.project_id == this.name_province) {
          list.push(e)

        }
      });
      res.forEach((e: any) => {
        if (e.project_id == this.name_province && e.type_money == 'เงินให้กู้ยืม') {
          this.detail_type_project2.push(e)
        }
      });
      res.forEach((e: any) => {
        if (e.project_id == this.name_province && e.type_money == 'เงินอุดหนุน') {
          this.detail_type_project3.push(e)
        }
      });
      res.forEach((e: any) => {
        if (e.project_id == this.name_province && e.type_money == 'เงินสนับสนุน') {
          this.detail_type_project4.push(e)
        }
      });
      res.forEach((e: any) => {
        if (e.project_id == this.name_province && e.type_money == 'เงินทดรองจ่าย') {
          this.detail_type_project5.push(e)
        }
      });


      res.forEach((f: any) => {
        if (f.province.match(list[0].province)) {
          this.detail_type_project.push(f)

          this.detail_project2 = this.detail_type_project[0]
        }
      });
    });



  }

  async initMap(geoJSON: any) {

    this.map = L.map('map', {
      attributionControl: false,
      center: [13.748431, 100.704130],
      zoom: 6
    });
    this.map2 = L.map('map2', {
      attributionControl: false,
      center: [13.748431, 100.704130],
      zoom: 6
    });

    this.map.createPane('left');
    this.map.createPane('right');
    var google = L.tileLayer('https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}', {
      maxZoom: 20
    }).addTo(this.map)


    var OpenStreetMap2 = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    })

    var CityPlan_view = L.tileLayer('https://map.nostramap.com/NostraMap/proxy.ashx?https://mapdynamic.nostramap.com/arcgis/rest/services/CityPlan_view/MapServer/tile/{z}/{y}/{x}', {
      //tms: true,
      maxZoom: 19
      //attribution: '&copy; <a href="https://map.nostramap.com">NostraMap</a>'
    }).addTo(this.map)

    L.tileLayer('https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}', {
      maxZoom: 20
    }).addTo(this.map2)

    function getColor(d: any) {
      return d > 50000000 ? '#800026' :
        d > 30000000 ? '#BD0026' :
          d > 10000000 ? '#E31A1C' :
            d > 5000000 ? '#FC4E2A' :
              d > 3000000 ? '#FD8D3C' :
                d > 1000000 ? '#FEB24C' :
                  d > 0 ? '#FED976' :
                    '#ffffff';
    }
    function style(feature: any) {
      return {
        fillColor: getColor(feature.properties.amount_receive),
        weight: 2,
        opacity: 1,
        color: 'white',
        dashArray: '3',
        fillOpacity: 0.3
      };
    }
    const province = geoJSON.features.find((e: any) => e.properties.project_id == this.name_province);
    let geoJSON_province = L.geoJSON(province, { style: style }).addTo(this.map2)
    this.bounds = geoJSON_province.getBounds()
    this.map2.fitBounds(geoJSON_province.getBounds())
    this.services.query_province_data({ name_province: this.name_province }).then((res_geoJSON: any) => {
      this.project(res_geoJSON)
    });

  }

  async project(json: any) {

    this.select_1 = [] as any
    this.select_2 = [] as any
    await this.services.view_geojson_file2().then((res: any) => {
      res.forEach((e: any) => {
        if (e.project_id == this.name_province) {
          this.select_1.push(e)
          this.select_id = e.geojson_id

          this.services.get_tbnamelist().then((res: any) => {

            res.forEach((e: any) => {
              if (e.id_project == this.select_id) {
                this.select_2.push(e)
              }
            });
          });

        }
      });

    });

    let select_pro = [] as any
    await this.services.view_geojson_file().then((res: any) => {
      res.forEach((e: any) => {
        if (e.lrfund_project_key == this.name_province) {
          select_pro.push(e)
        }
      });

      select_pro.sort(function (a: any, b: any) {
        return a.gid - b.gid;
      });

      if (this.select_1.length != 0) {
        this.get_geoJSON(this.select_2[0].parcel_af).then((parcel_af: any) => {
          this.get_geoJSON(this.select_2[0].parcel_be).then((parcel_be: any) => {
            this.show_landuse(parcel_af, parcel_be)
          })
        })
        this.showmap = true;
      } else if (select_pro.length > 0) {
        this.showmap = true;
        var arr = select_pro[1].file_name.split('_');
        var arr2 = select_pro[2].file_name.split('_');
        var folder = 'boundary/';
        var folder2 = 'boundary/';
        if (arr[0] == 'parcel') {
          folder = `${arr[0]}_${arr[1]}/`;
        }

        if (arr2[0] == 'parcel') {
          folder2 = `${arr2[0]}_${arr2[1]}/`;
        }

        this.get_geoJSON(folder + select_pro[1].file_name).then((parcel_af: any) => {
          this.get_geoJSON(folder2 + select_pro[2].file_name).then((parcel_be: any) => {
            this.show_landuse(parcel_af, parcel_be)
          })
        })

      } else {
        this.showmap = false;
        this.show_landuse_image();
      }
      // console.log(this.showmap);

    });

    this.detail_project = json[0]

    this.name_project = this.detail_project.province
    let f = await this.services.list_id_province.find((e: any) => e.pv_tn === this.name_project);
    this.id_province = f.id;
    await this.services.location_project(this.id_province).then((res: any) => {
      if (res.length > 0) {
        this.lat = Number(res[0].lat)
        this.lon = Number(res[0].lon)
      } else {
        this.lat = Number(json[0].lat)
        this.lon = Number(json[0].lon)
      }
      this.geoJSON = json
      L.marker([this.lat, this.lon]).addTo(this.layer_marker)
        .bindPopup('ตำแหน่งที่ตั้งโครงการ')
        .openPopup();
      this.layer_marker.addTo(this.map2);

    })


  }

  editLocation() {
    if (this.layer_marker != undefined) {
      this.layer_marker.clearLayers()
      this.map2.pm.enableDraw('Marker', { snappable: false });
      this.map2.on('pm:create', (e: any) => {
        // Check if the created layer is a marker
        if (e.layer instanceof L.Marker) {
          // Remove the marker from the map
          this.map2.removeLayer(e.layer);
        }
        Swal.fire({
          icon: 'question',
          title: 'เปลี่ยนตำแหน่งที่ตั้งโครงการ ?',
          showCancelButton: true,
          confirmButtonText: 'ตกลง',
          denyButtonText: `ยกเลิก`,
        }).then((result) => {
          if (result.isConfirmed) {
            this.lat = e.marker._latlng.lat;
            this.lon = e.marker._latlng.lng;
            this.map2.pm.disableDraw('Marker');
            L.marker([this.lat, this.lon]).addTo(this.layer_marker)
              .bindPopup('ตำแหน่งที่ตั้งโครงการ')
              .openPopup();
            this.services.project_location({ lat: this.lat, lon: this.lon, id_province: this.id_province }).then((res: any) => {
              if (res.insert == 'true') {
                Swal.fire({
                  icon: 'success',
                  title: 'บันทึกตำแหน่งที่ตั้งโครงการใหม่แล้ว',
                  timer: 1500
                })
              }
            })
          }
        })

      })
    }
  }

  backReport() {
    this._location.back();
  }

  show_landuse_image() {

    this.services.project_file_image(this.name_province).then((res: any) => {
      if (res.length > 0) {
        res[0].image_be = this.services.base_path + res[0].image_be;
        res[0].image_af = this.services.base_path + res[0].image_af;
        res[0].path_be = res[0].image_be.replace(this.services.base_path, "");
        res[0].path_af = res[0].image_af.replace(this.services.base_path, "")
        this.project_image = res[0];
        this.map.fitBounds(this.bounds)
        var layer_be = L.imageOverlay(this.project_image.image_be, this.bounds, {
          opacity: 1,
          interactive: true
        }).addTo(this.map)

        var layer_af = L.imageOverlay(this.project_image.image_af, this.bounds, {
          opacity: 1,
          interactive: true
        })

        var baseMaps = {
          "แผนผังก่อนโครงการ": layer_be,
          "แผนผังหลังโครงการ": layer_af,
        }

        var overlayMaps = {
          // "แผนผังก่อนโครงการ": layer_be,
          // "แผนผังหลังโครงการ": layer_af,
        };

        L.control.layers(baseMaps, overlayMaps, { collapsed: false }).addTo(this.map);

      }
    })
  }

  show_landuse(parcel_af: any, parcel_be: any) {

    function getColor(d: any) {
      return d == 'RL' ? '#FF5D00' :
        d == 'PARK' ? '#0CFF00' :
          '#eeecda';
    }
    function style(feature: any) {
      return {
        fillColor: getColor(feature.properties.type_land),
        weight: 2,
        opacity: 1,
        color: 'white',
        fillOpacity: 0.7
      };
    }

    function style2(feature: any) {
      return {
        fillColor: "#eeecda",
        width: 5,
        opacity: 1,
        color: 'white',
        fillOpacity: 0.7
      };
    }

    let add_parcel_af = L.geoJSON(parcel_af, {
      style: style
    })

    let add_parcel_bf = L.geoJSON(parcel_be, {
      style: style2
    }).addTo(this.map)

    var baseMaps = {

    };

    var overlayMaps = {
      "แผนผังก่อนโครงการ": add_parcel_bf,
      "แผนผังหลังโครงการ": add_parcel_af,
    };

    L.control.layers(baseMaps, overlayMaps, { collapsed: false }).addTo(this.map);
    this.map.fitBounds(add_parcel_bf.getBounds())
  }

  get_geoJSON(data: any) {
    return new Promise((res, rej) => {
      if (this.select_1.length != 0) {
        this.http.get('https://ogc.mapedia.co.th/api/v1/websheet/upload/' + data)
          .subscribe((data: any) => {
            res(data)
          }, (err: any) => {
            rej(err)
          });
      } else {
        this.http.get('assets/geojson/' + data)
          .subscribe((data: any) => {
            res(data)
          }, (err: any) => {
            rej(err)
          });
      }
    });
  }

  clickMenuIcon() {
    document.getElementById('sidebar')!.classList.toggle("active");
  }
  async onClickListMenu() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }


  file: any;
  type: any = 'image_be';
  filedata: any;
  fileSource: any;

  openForm(type: any) {
    this.type = type;
  }

  onFileData(event: any) {
    this.filedata = null;
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;

      // console.log(file);


      this.file = event.target.files[0];
      // this.data_file.push(event.target.files[0]);

      reader.readAsDataURL(file);

      reader.onload = () => {

        this.filedata = reader.result as string;
        this.fileSource = reader.result;
        //   this.uploadForm.patchValue({
        //     fileSource: reader.result
        //   });
      }

    };

    // console.log(this.data_file);
  }

  submit() {
    var path = "";
    var title = "ก่อนโครงการ";
    if (this.type == 'image_be') {
      path = this.project_image.path_be;

    } else {
      path = this.project_image.path_af;
    }
    var data = {
      project_id: this.name_province,
      type: this.type,
      fileSource: this.filedata,
      path: path
    }
    this.services.upload_file(data).then((res: any) => {
      if (res.insert) {
        Swal.fire({
          title: `อัปโหลดภาพ${title}เรียบร้อยแล้ว`,
          icon: 'success',
          timer: 1500,
        })
        this.initMap(this.geo_province)
      }
    })
    $('#upload_landparcel').modal('hide');

  }



}
